import { router } from './router';
import { DMS_MODULE } from './constants';

export const Kartoteka = {
	name: DMS_MODULE,
	router,
};
